// Entitlement gate for "New Campaign Activity → Dialer".
//
// The rules were written for My Property (Property/Group/index.js#handleNewCampaign)
// and then copied into the Investor List. Copying them a third time for Investor
// Outreach's Actions dropdown would be three places to keep in step, so the
// checks live here and every entry point calls this before it opens the campaign
// activity modal.
//
// Order matters and mirrors the original:
//   1. TEAM sub-users never get the dialer — they get the Full Access modal.
//      This is checked before the plan check so a TEAM user on a plan without
//      Lead Automator sees the accurate reason.
//   2. No Lead Automator entitlement → upgrade path, which differs by plan:
//      a legacy account has no LA add-on to buy, so it goes straight to the
//      plan page; everyone else gets the LA upsell modal.
//
// Returns true when the caller may proceed. When it returns false it has
// already shown the user why, so the caller just bails.
//
// NOTE: `openLeadAutomatorUpgrade` only flips a redux flag — the screen calling
// this must also render <LeadAutomatorUpgrade /> or the modal never appears.
export const checkDialerCampaignAccess = ({
  profile,
  lmEnabled,
  isLegacyAccount,
  openFullAccessRequiredModal,
  closeFullAccessRequiredModal,
  openLeadAutomatorUpgrade,
  leaveMessagePopup,
  history,
}) => {
  const userType = profile?.get?.('type');

  if (userType === 'TEAM') {
    openFullAccessRequiredModal({ onClose: closeFullAccessRequiredModal });
    return false;
  }

  if (!lmEnabled) {
    if (isLegacyAccount) {
      // Legacy without LA → go directly to plan upgrade, skip the LA modal
      leaveMessagePopup({
        title: 'Upgrade Your Account',
        message: 'Upgrade your account to Essentials, Pro, or Elite by clicking Upgrade Plan to continue.',
        autoWidth: false,
        yesLable: 'Upgrade Plan',
        cancelLable: 'Cancel',
        yesRedirect: () => history.push('/accountnew/plan'),
      });
    } else {
      openLeadAutomatorUpgrade(true);
    }
    return false;
  }

  return true;
};

export default checkDialerCampaignAccess;
